import { Modal } from 'antd';
import { useEffect } from 'react';
import { useBlocker } from 'react-router';
import { useStore } from 'src/store/reducers';

/** Asks before leaving the event editor while a geo element batch, e.g. a file import, is saved. */
export const useGeoSaveLeaveGuard = (eventId: string | undefined) => {
  const isSaving = useStore((s) => s.events.isSavingGeoElements);
  const blocker = useBlocker(
    ({ nextLocation }) =>
      isSaving && !nextLocation.pathname.startsWith(`/admin/events/${eventId}/`),
  );

  useEffect(() => {
    if (blocker.state !== 'blocked') return;

    Modal.confirm({
      title: 'Geo elements are still being saved',
      content: 'If you leave this map now, the import goes on in the background.',
      okText: 'Leave anyway',
      cancelText: 'Stay',
      onOk: () => blocker.proceed(),
      onCancel: () => blocker.reset(),
    });
  }, [blocker.state]);
};
